// extracted by mini-css-extract-plugin
export var clickBlocker = "_kg-c";
export var interactivePassthrough = "_kg-4";
export var lookHere = "_kg-3";
export var modal = "_kg-e";
export var modalBackdrop = "_kg-d";
export var modalBody = "_kg-p";
export var modalBodyHero = "_kg-q";
export var modalDescription = "_kg-s";
export var modalEnter = "_kg-f";
export var modalFooter = "_kg-t";
export var modalFooterHero = "_kg-u";
export var modalHeaderText = "_kg-n";
export var modalHeroImage = "_kg-i";
export var modalHeroTitle = "_kg-l";
export var modalIconCircle = "_kg-o";
export var modalIconHeader = "_kg-m";
export var modalImageLabel = "_kg-k";
export var modalImageOverlay = "_kg-j";
export var modalImageWrapper = "_kg-h";
export var modalTitle = "_kg-r";
export var modalWithHero = "_kg-g";
export var pulse = "_kg-1";
export var pulseBorder = "_kg-2";
export var spotlight = "_kg-0";
export var tooltip = "_kg-5";
export var tooltipButtons = "_kg-a";
export var tooltipDescription = "_kg-7";
export var tooltipFooter = "_kg-8";
export var tooltipInteractiveHint = "_kg-b";
export var tooltipStepIndicator = "_kg-9";
export var tooltipTitle = "_kg-6";